import React from "react";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Stav", "caption": "Stav", 'filter': 'string'},
    {"label": "Uzavrety", "caption": "Uzavretý", 'filter': 'bool'},
    {"label": "Farba", 'filter': 'string'}
]

function BTKStates(props) {
    const initialFilters = [
        {
            'label': 'Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Uzavrety',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Farba',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Stav',
        }
    ]
    const baseUrl = '/btk/btks_states'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Stav': `/btk_states/btk_state/${entry.id}`
        }))
    }

    function colorize() {
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0,1)
        new_rows.forEach(row => {
            const cell = row.getElementsByTagName("td")[2]
            const color = cell.innerText
            cell.style.backgroundColor = color
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data])

    return (
        <ListViewCommon baseUrlFrontend={`/btk_states/btk_state`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Stavy BTK"}
        />
    )
}

export default BTKStates
